import React from 'react';
import { Card, Panel } from '@/components/Bicester';
import { BICESTER_FULL_DATE_HOURS_MINUTES } from '@/constants/dateFormat';
import { LeaseBasic, ReadyContext } from '@/providers/ReadyProvider';

const LeaseInfoForm = ({ leaseBasic }: { leaseBasic: LeaseBasic }) => {
  const { profile } = React.useContext(ReadyContext);

  return (
    <Panel title="租赁信息" leftShadow>
      <Card smDivider>
        <div className="flex items-center">
          <Card.DatePicker
            required
            label="租赁开始时间"
            formKey="start_date"
            format={BICESTER_FULL_DATE_HOURS_MINUTES}
          />
          <Card.Input notEditable label="服务大使" formKey="ge_name" value={profile?.user_name} />
          <Card.Picker
            required
            label="质押方式"
            formKey="pledge_type"
            pickerData={leaseBasic.pledge_type}
            searchable
          />
          <Card.Input label="质押金额" formKey="pledge_price" inputType="price" />
        </div>
        <div className="flex w-[75%]">
          <Card.Input label="POS小票编号" formKey="pos_no" />
          <Card.Input
            label="备注"
            formKey="remark"
            className="flex-[2]"
            labelWeight={1}
            contentWeight={3}
          />
        </div>
      </Card>
    </Panel>
  );
};

export default LeaseInfoForm;
